import type { GlbSceneConfig } from '../glb/glbSceneConfig';
import type { SceneConfig } from '../sceneConfig';
import { blackStoneSceneConfig } from './blackStone';
import { goldenSpoutSceneConfig } from './goldenSpout';
import { maqamIbrahimSceneConfig } from './maqamIbrahim';

export type PoiArtifactType = 'glb' | 'splat';

export type PoiArtifactEntry =
  | { type: 'glb'; config: GlbSceneConfig }
  | { type: 'splat'; config: SceneConfig };

const poiArtifactConfigs: Record<string, PoiArtifactEntry> = {
  'black-stone-scene': { type: 'glb', config: blackStoneSceneConfig },
  'golden-spout-scene': { type: 'glb', config: goldenSpoutSceneConfig },
  'maqam-ibrahim-scene': { type: 'glb', config: maqamIbrahimSceneConfig },
};

export const getPoiArtifactConfig = (
  id: string,
): PoiArtifactEntry | undefined => poiArtifactConfigs[id];

export const isPoiArtifact = (id: string): boolean => id in poiArtifactConfigs;

export const getPoiArtifactIds = (): string[] => Object.keys(poiArtifactConfigs);
